export const SET_LOADING = (state, value) => { state.loading = value; };
export const SET_ERROR = (state, value) => { state.error = value; };
export const SET_WALLET = (state, value) => { state.wallet = value; };
export const SET_MOVEMENTS = (state, value) => { state.movements = value || { docs: [] }; };
export const SET_SURVEYS = (state, value) => { state.surveys = value || []; };
export const SET_ADMIN_SURVEYS = (state, value) => { state.adminSurveys = value || []; };
export const SET_ELIGIBILITY = (state, value) => { state.eligibility = value; };
export const SET_SOFOMES = (state, value) => { state.sofomes = value || { docs: [] }; };
export const SET_RULES = (state, value) => { state.rules = value || []; };
export const SET_ADMIN_WALLET = (state, value) => { state.adminWallet = value; };
export const SET_ADMIN_MOVEMENTS = (state, value) => { state.adminMovements = value || { docs: [] }; };
